export default __webpack_public_path__ + "static/media/dponet-logo-white.670b6e00.svg";